<template>
  <div class="ls-box">
    <h5 class="ls-title-5 ls-md-margin-bottom" :class="{ 'ls-color-theme' : $parent.$data.forms.email }"><i class="fa fa-user-o" aria-hidden="true"></i> {{ $t('subscribe.titles.identify') }}</h5>
    <form class="ls-form" @submit.prevent="validateBeforeSubmit">
      <fieldset>
        <div class="row">
          <div class="col-md-8">

            <MaterialInput
              type="email"
              label="Email"
              ref="email"
              ico="fa fa-envelope-o"
              focused="true"
              data-vv-name="email"
              v-validate="'required|email'"
              v-model="$parent.$data.email"
              :blurCallback="validateBeforeSubmit"
              :class="{ 'material--active material--has-errors': errors.has('email') }"
              :has-error="errors.has('email')">
                {{ $t('subscribe.attributes.email') }}
                <small class="material-errors" slot="help-message" v-if="errors.has('email')">{{ errors.first('email') }}</small>
                <i class="fa fa-check" slot="ico-check" aria-hidden="true" v-if="!errors.has('email') && $parent.$data.email"></i>
            </MaterialInput>

          </div>
          <div class="col-md-3">
            <button class="btn btn-act next btn-fixed-bottom-xs" :disabled="errors.has('email')">{{ $t('application.button.continue') }} <span class="ls-ico-chevron-right ls-display-none-sm ls-display-none-md ls-display-none-lg"></span></button>
          </div>
        </div>
        <button type="button" @click="$parent.backToSignaturePlans" class="btn prev btn-fixed-bottom-xs ls-display-none-sm ls-display-none-md ls-display-none-lg"><span class="ls-ico-chevron-left"></span>{{ $t('subscribe.buttons.choose_plan') }}</button>
      </fieldset>
    </form>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import MaterialInput from '../../../components/shareds/MaterialInput.vue'

  export default {
    name: 'email-form',
    components: { MaterialInput },
    methods: {
      ...mapActions(['verifyEmail']),
      getEmail () {
        // busca se já tem o customer cadastrado
        this.verifyEmail(this.$parent.$data.email).then(this.afterGetEmail)
      },
      afterGetEmail (response) {
        this.$parent.$data.forms.email = false
        if (response !== undefined && response.status === 200) {
          if (!window.localStorage.customer) { this.$parent.$data.forms.login = true }
        } else {
          window.localStorage.removeItem('customer')
          window.localStorage.removeItem('customerCPF')
          window.localStorage.removeItem('customerEmail')
          this.$parent.$data.forms.signup = true
        }
        this.$loader.hide()
      },
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validateAll().then(this.afterValidate)
      },
      afterValidate (result) {
        if (result) {
          this.getEmail()
        } else {
          this.$loader.hide()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailForm.vue?a7a75730